export default {
	addAppToList(state, payload) {
		state.list.unshift(payload)
	},

	putAppDetail(state, payload) {
		state.detail = { ...payload }
	},

	putAppsList(state, payload) {
		state.list = payload
	},

	removeAppFromList(state, appId) {
		state.list = state.list.filter(item => item.appId !== appId)
	}
}
